// src/features/services/api/services.api.ts
import { apiClient } from '../../../app/api/apiClient';

/**
 * The exact response shape for GET /api/services hasn't been shared
 * (same situation the customers/support modules were in before their
 * contracts were confirmed by usage). Field names below are the ones
 * most consistent with the rest of the backend's snake_case DTOs;
 * adjust here — and only here — once the real contract is confirmed.
 */
export interface ServiceDTO {
  id: number | string;
  name?: string;
  plan_name?: string;
  customer_name?: string;
  status?: string;
  expires_at?: string;
}

interface ServicesResponse {
  services: ServiceDTO[];
}

export async function fetchServices(): Promise<ServicesResponse> {
  const response = await apiClient.get<ServicesResponse>('/api/services');

  return response.data;
}
